import styled from 'styled-components';

export const OptionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  &.vertical {
    flex-direction: column;
    > label {
      width: max-content;
      max-width: 100%;
    }
  }
`;
